import { ApiService } from './../../api.service';
import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/auth.service';
import { MatSnackBar } from '@angular/material';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  isEditDisabled = true;
  user: any = {};

  files: any = [];

  maxDob: Date;

  isRequesting: boolean;
  uploadedNeeded: boolean;

  constructor(
    public loginService: LoginService,
    public snackBar: MatSnackBar,
    private titleService: Title,
    public api: ApiService
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Autoscoop - Profile Settings');
    this.api.getUserDetails().subscribe(
      r => {
        this.user = r;
      },
      error => {
        this.user = null;
        console.log(error);
      }
    );
    const eighteenYearsAgo = new Date();
    this.maxDob = new Date(
      eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18)
    );
  }

  uploadedNeed(result) {
    this.uploadedNeeded = true;
  }

  onImageUploaded(img) {
    if (img !== '') {
      this.files.push(img);
      this.uploadedNeeded = false;
    }
  }

  toggleEdit() {
    this.isEditDisabled = !this.isEditDisabled;
  }

  editProfile() {
    this.isRequesting = true;
    const data = {
      photo: this.files.length > 0 ? this.files[0] : this.loginService.getAvatar(),
      dob: this.user.dateOfBirth,
      gender: this.user.gender,
      phoneNumber: this.user.mobile,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      streetNumber: this.user.streetNumber,
      streetName: this.user.streetName,
      postCode: this.user.postCode,
      region: this.user.drivingLicense,
      state: this.user.state,
      desc: this.user.desc,
    };
    this.api.editProfile(data).subscribe(
      r => {
        console.log(r);
        this.isRequesting = false;
        this.snackBar.open('The profile has been updated.');
      },
      error => {
        console.log(error);
        this.isRequesting = false;
      }
    );
  }
}
